import { Component, OnInit } from "@angular/core";
import { TitleService } from 'src/app/_services/title.service';

@Component({
  selector: "company-profile-layout",
  templateUrl: "./company-profile.layout.html",
  host: { 'class': 'tab-content' },
  styleUrls: ['./company-profile.layout.scss']
})
export class CompanyProfileLayout implements OnInit {
  title = "cards.lexi_market_settings.lxm_settings_company_profile.title";

  constructor(private _titleService: TitleService) { }

  public ngOnInit() {
    this._titleService.setTitle(this.title);
  }

}
